import React from 'react';
import {Typography, Link, Box} from '@mui/material';

const Copyright = () => {
return (
    <Box component="span" display="flex" flexDirection="column" justifyContent="flex-end" 
        sx={{
            position: 'fixed',
            bottom: '5px',
            width: "99vw"
        }}
    >
        <Typography variant="body1" 
            sx={{
                fontSize: '11px',
                fontWeight: 'bold',
                color: "#fff"
            }}
        >© {new Date().getFullYear()} <Link color="inherit" href="https://www.tirefax.com/">tirefax</Link> Licensing™ (Trademark) - All Rights Reserved</Typography>
    </Box>
)
}
export default Copyright